import { Component, Inject, OnDestroy } from '@angular/core';
import { IHypervisionService } from '@hypervision/hypervision.service';

import { NG1_HYPPERVISION_SERVICE } from './hypervision-for-root.module';
import { HypervisionRouter } from './hypervision-router';
import { HypervisionState } from './hypervision-routing.module';

@Component({
  selector: 'cng-hypervision',
  templateUrl: './hypervision.component.html',
  styleUrls: ['./hypervision.component.scss'],
})
export class HypervisionComponent implements OnDestroy {
  readonly HypervisionState = HypervisionState;
  openCenter = false;
  openSkill = false;

  readonly url$ = this.router.currentUrl$;

  constructor(
    @Inject(NG1_HYPPERVISION_SERVICE) private readonly hypervision: IHypervisionService,
    private readonly router: HypervisionRouter
  ) {}

  isState(currentUrl: string, ...targetPaths: string[]): boolean {
    const [lastCurrentPath] = currentUrl.split('/').reverse();
    return targetPaths.some(path => path === lastCurrentPath);
  }

  toggleCenter() {
    this.openCenter = !this.openCenter;
  }

  toggleSkill() {
    this.openSkill = !this.openSkill;
  }
  ngOnDestroy() {
    this.hypervision.reset();
  }
}
